import { EntityDetailDialogs } from "#app/components/entity";
import { GlobalSearchDialog } from "#app/components/global-search/global-search-dialog";
import { IssueViewDialogs } from "#app/components/issue-view";
import { AppearanceSheetMount } from "#app/components/menus/appearance-sheet-mount";
import { AdminDialogMount } from "#app/lib/admin-dialog-context";
import { AutomationRunsDialogMount } from "#app/lib/automation-runs-dialog-context";
import { AutomationsDialog } from "#app/lib/automations-dialog-context";
import { CustomFieldsDialog } from "#app/lib/custom-fields-dialog-context";
import { FormBuilderDialogMount } from "#app/lib/form-builder-dialog-context";
import { FormFillDialogMount } from "#app/lib/form-fill-dialog-context";
import { IntegrationsDialog } from "#app/lib/integrations-dialog-context";
import { IssueTypeMigrationDialogMount } from "#app/lib/issue-type-migration-dialog-context";
import { ItemShareDialogMount } from "#app/lib/item-share-dialog-context";
import { KeyboardShortcutsDialogMount } from "#app/lib/keyboard-shortcuts-dialog-context";
import { LogoutConfirmDialogMount } from "#app/lib/logout-confirm-dialog-context";
import { MentionAccessDialogMount } from "#app/lib/mention-access-dialog-context";
import { NavDialogsMount } from "#app/lib/nav-dialogs-context";
import { StagesDialogMount } from "#app/lib/stages-dialog-context";
import { WhatsNewDialogMount } from "#app/lib/whats-new-dialog-context";

/**
 * The app-level dialogs that own sheets of their own — the project view, the
 * entity details, global search — mounted once at the workspace root.
 */
export function WorkspaceDialogMounts() {
  return (
    <>
      <GlobalSearchDialog />
      <IssueViewDialogs />
      <EntityDetailDialogs />
    </>
  );
}

/**
 * Every other app-level dialog, mounted once through the layout's
 * `DialogHostProvider`: they render inside the innermost open sheet, so one
 * opened from a sheet (Share from the project view) stacks on it. Each is
 * driven by its own `createDialogEmitter` (or its own store), so a caller
 * anywhere in the tree, or outside it, opens the dialog without context.
 */
export function HostedDialogMounts() {
  return (
    <>
      <CustomFieldsDialog />
      <StagesDialogMount />
      <FormFillDialogMount />
      <FormBuilderDialogMount />
      <AppearanceSheetMount />
      <IntegrationsDialog />
      <KeyboardShortcutsDialogMount />
      <LogoutConfirmDialogMount />
      <WhatsNewDialogMount />
      <AutomationsDialog />
      <AutomationRunsDialogMount />
      <AdminDialogMount />
      <ItemShareDialogMount />
      <MentionAccessDialogMount />
      <NavDialogsMount />
      <IssueTypeMigrationDialogMount />
    </>
  );
}
